import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { readPermissionForAppPath } from './permissions';
import { useTenantPermissions } from './TenantPermissionsContext';

type Props = {
  children: ReactNode;
  /** Permiso explícito; si no se pasa, se infiere de la ruta `/app`. */
  permission?: string | string[];
};

export function RequirePermission({ children, permission }: Props) {
  const { loading, can } = useTenantPermissions();
  const loc = useLocation();

  if (loading) {
    return <p style={{ padding: 24, color: '#64748b' }}>Cargando permisos…</p>;
  }

  const required =
    permission ??
    (() => {
      const p = readPermissionForAppPath(loc.pathname);
      return p ? [p] : ['web.dashboard.read'];
    })();

  if (!can(required)) {
    return <Navigate to="/app" replace state={{ forbidden: true }} />;
  }

  return children;
}
